export enum OrderPaymentEnum {
  CASH = 'CASH',

  BANK_CARD_IN_APP = 'BANK_CARD_IN_APP',

  BANK_CARD_IN_STORE = 'BANK_CARD_IN_STORE',
}
